module.exports = __webpack_public_path__ + "static/media/daniel.77e89760.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daniel.png
// module id = 18
// module chunks = 0